<template>
  <div class="propertyContractList">
    <div class="filters">
      <div class="jump-btn">
        <el-button type="primary" slot="header" @click="back">返回</el-button>
      </div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="contractTypeId">
            <el-option key label="请选择合同类别" value=''></el-option>
            <el-option v-for="item in contractType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="getData()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add()">新增服务合同</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName">
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="contractName" label="合同名称" align="center"></el-table-column>
        <el-table-column prop="contractType" label="合同类别" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.contractType == 1">前期物业服务合同</span>
            <span v-if="scope.row.contractType == 2">后期物业服务合同</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractSignDate" label="合同签订时间" align="center"></el-table-column>
        <el-table-column prop="contractDate1" label="合同生效时间" align="center"></el-table-column>

        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          align="center" :width="require('@/config/enum').opr_width4">
          <template slot-scope="scope">
            <el-button @click="editOne(scope.row.id)">修改</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  export default {
    name: '/manage/main.propertyContractList',
    data() {
      return {
        cellphone: '',
        projectName: '', // 合同名称
        contractTypeId: '', // 服务合同类别
        contractType: this.$i18n.t('lang.contractType'),
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        form: {
          cellphone: '',
          payPrice: '',
          buyNum: '',
          skuInfo: '',
          isSyncPoint: 0
        },
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 初始化
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 新增
      add() {
        this.$router.push({
          name: 'propertyContractAdd'
        })
      },
      // 修改
      editOne(id) {
        this.$router.push({
          name: 'propertyContractAdd',
          query: {
            id: id
          }
        })
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/gardenDrawGardenContract/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 获取数据
      getData() {
        let loading = this.$loading()
        this.$get(
          `/gardenDrawGardenContract?gardenId=${this.gardenId}&projectName=${this.projectName}&contractType=${this.contractTypeId}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.getData()
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
    }
  }
</script>

<style lang="scss">
</style>